import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import './globalStyle';
import FastClick from 'fastclick';
import { SurveyCakeLogicEngine } from '@surveycake/logic-engine';
import { gaId, gtmId, amplitudeKey, userAgent } from 'config/system';
import { SurveyConfig } from 'app/core/survey-config';
import { Tracker } from 'app/core/tracker';
import { surveyHash, referral, tempAnswerHash } from 'app/shared/utils/locationPathnameInfo';
import { isDevelopment } from 'app/shared/utils/development';
import { disableReactDevtools } from './disableReactDevtools';
import { bootstrapApp } from './app';
import iOS12iframeHack from './iOS12iframeHack';
import TagManager from 'react-gtm-module';

iOS12iframeHack();

if (isDevelopment && window.location.pathname === '/') {
  window.location.href = '/s/v2xZp';
}

const surveyConfig = new SurveyConfig(surveyHash, referral, tempAnswerHash);
const engine = new SurveyCakeLogicEngine();
const tracker = new Tracker(surveyConfig, gaId, amplitudeKey);

tracker.trackEnterSurvey();

if (!isDevelopment) {
  disableReactDevtools();
}

if (userAgent.isIOS) {
  //	@ts-ignore
  FastClick.attach(document.body)
  FastClick.prototype.focus = function(targetElement: HTMLInputElement) {
    let length;
    if (
      targetElement.setSelectionRange &&
      targetElement.type.indexOf('date') !== 0 &&
      targetElement.type !== 'time' &&
      targetElement.type !== 'month'
    ) {
      length = targetElement.value.length;
      targetElement.focus();
      targetElement.setSelectionRange(length, length);
    } else {
      targetElement.focus();
    }
  };
}

TagManager.initialize({ gtmId });

bootstrapApp({
  infos: {
    element: document.getElementById('survey')
  },
  providers: [engine, surveyConfig, tracker]
});
